import { gql } from '@apollo/client';

export const CREATE_FILTERING_RULE_GROUP_MUTATION = gql`
  mutation createFilteringRule(
    $name: String!
    $groupRule: String!
    $filteringRules: [FilteringRuleInputObject!]!
  ) {
    createFilteringRuleGroup(
      name: $name
      groupRule: $groupRule
      filteringRules: $filteringRules
    ) {
      filteringRuleGroup {
        id
        name
      }
    }
  }
`;

export const EDIT_FILTERING_RULE_GROUP_MUTATION = gql`
  mutation editFilteringRuleGroup(
    $id: Int!
    $name: String!
    $groupRule: String!
    $filteringRules: [FilteringRuleInputObject!]!
  ) {
    editFilteringRuleGroup(
      id: $id
      name: $name
      groupRule: $groupRule
      filteringRules: $filteringRules
    ) {
      filteringRuleGroup {
        id
        name
      }
    }
  }
`;
